import {ApiMethods, CONTENT_TYPE_JSON, CONTENT_TYPE_EXCEL} from './constants';
import {redirectToLoginPage} from '../utils';

export {ApiMethods} from './constants';

const getRootApi = () => process.env.API_ROOT || '/';

interface ICallArgs {
    endpoint: string;
    method: string;
    body?: any;
    headers?: any;
}

type CallApi = (callArgs: ICallArgs) => Promise<any>;

const defineType = (r: any) => {
    const response = r.headers.get('Content-Type');

    switch (response) {
        case CONTENT_TYPE_JSON:
            return r.json();
        case CONTENT_TYPE_EXCEL:
            return r.arrayBuffer();
        default:
            return r.text();
    }
};

const responseToPromise = (r: Response): Promise<object | string> => defineType(r);

const handleResponse = (response: Response, responseData: object | string) => {
    if (response.status === 401) {
        localStorage.removeItem('accessToken');
        redirectToLoginPage();

        return {httpStatus: response.status};
    } else {
        return {
            responseData,
            httpStatus: response.status
        };
    }
};

const callApi: CallApi = (callInfo) => {
    const API_ROOT = `${getRootApi()}api/`;
    const {endpoint, method = ApiMethods.GET, body, headers} = callInfo;

    return fetch(`${API_ROOT}${endpoint}`, {
        method,
        body: JSON.stringify(body),
        headers: {
            Accept: CONTENT_TYPE_JSON,
            'X-Requested-With': 'XMLHttpRequest',
            AUTHORIZATION: `Bearer ${localStorage.getItem('accessToken') || ''}`,
            'Content-Type': 'application/json',
            ...headers
        }
    })
        .then((response) => responseToPromise(response).then((responseData) => handleResponse(response, responseData)))
        .catch((error) => {
            return Promise.reject(error);
        });
};

const Api = {
    fetch: callApi
};

export default Api;
